import Icon from 'veui/components/Icon'
import { IconPencil } from 'dls-icons-vue'

Icon.register('pencil', IconPencil)
